import { getString } from '@biw/intl';
import get from 'lodash/get';

const EMPTY_ARRAY: any[] = [];

const Errors = {

    // client-dux errors
    ERROR_CLIENT_FETCHCLIENTDATA: 'ERROR_CLIENT_FETCHCLIENTDATA',
    ERROR_CLIENT_FETCHENVDATA: 'ERROR_CLIENT_FETCHENVDATA',
    ERROR_CLIENT_FETCHCLIENTCOUNTRIES: 'ERROR_CLIENT_FETCHCLIENTCOUNTRIES',

    // rules-dux errors
    ERROR_EXPORT_RULES_FAILED: 'ERROR_EXPORT_RULES_FAILED',

    // contact-us-dux errors
    ERROR_CONTACTUS_SUBMISSION_FAILED: 'ERROR_CONTACTUS_SUBMISSION_FAILED',

    // onboarding-dux errors
    ERROR_ONBOARDING_UPLOADONBOARDINGDATA: 'ERROR_ONBOARDING_UPLOADONBOARDINGDATA',

    // profile-dux errors
    ERROR_PROFILE_CHANGEPASSWORD: 'ERROR_PROFILE_CHANGEPASSWORD',
    ERROR_PROFILE_SETUSERLOCALE: 'ERROR_PROFILE_SETUSERLOCALE',
    ERROR_PROFILE_UPLOADUSERAVATAR: 'ERROR_PROFILE_UPLOADUSERAVATAR',
    ERROR_PROFILE_ACCOUNT_HISTORY: 'ERROR_PROFILE_ACCOUNT_HISTORY',

    // shop-dux errors
    ERROR_SHOP_FETCH_CATALOG_URL: 'ERROR_SHOP_FETCH_CATALOG_URL',

    // sso-authenticated errors
    ERROR_SSO_AUTHENTICATED_NO_SESSIONID: 'ERROR_SSO_AUTHENTICATED_NO_SESSIONID',
    ERROR_SSO_AUTHENTICATED_FETCH_PROFILE: 'ERROR_SSO_AUTHENTICATED_FETCH_PROFILE',
    ERROR_SSO_AUTHENTICATED: 'ERROR_SSO_AUTHENTICATED',
    ERROR_SSO_AUTHENTICATED_INVALID_CREDENTIALS: 'ERROR_SSO_AUTHENTICATED_INVALID_CREDENTIALS',

    getByType( state: any, errorType: string ) {
        const errorList = get( state, 'error.errorList' );
        if ( !errorList || errorList.length === 0 ) {
            return EMPTY_ARRAY;
        }

        return errorList
            .filter( (error: any) => error.errorType === errorType )
            .map( (error: any) => {
                error.state = state;
                return error;
            } );
    },

};

export default Errors;

export class LocalizedError {
    public localeBundleKey = '';
    constructor( error: Error, localeBundleKey: string ) {
        this.constructor.prototype = error;
        this.localeBundleKey = localeBundleKey;
    }

    public getLocalizedMessage( state: any ) {
        return getString( state, this.localeBundleKey );
    }
}
